
import { defineComponent, ref, Ref } from 'vue';
import utilities from '@/shared/utilities.service';

export default defineComponent({
    name: 'ClipboardCopy',
    props: {
        text: {
            required: false,
            type: String,
            default: '',
        },
    },
    setup(props) {
        const timing: number = 3000;
        const pending: Ref<boolean> = ref(false);

        const copy = async(): Promise<any> => {
            if (!pending.value) {
                pending.value = true;
                const animationTiming = utilities.delay(timing);
                const copyToClipboard = utilities.copyTextToClipboard(props.text);
                await Promise.all([
                    animationTiming,
                    copyToClipboard,
                ]);
                pending.value = false;
            }
        };

        return {
            pending,
            copy,
        };
    },
});
